import { absolutePathWithArrayIndices } from "../absolutePath";
import type { AnalyticsApiParams } from "./types";

export const devices = {
  mobile_web_devices: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/devices/mobile_web_devices",
      params,
    ),
  total_ios_devices: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/devices/total_ios_devices", params),
  total_android_devices: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/devices/total_android_devices",
      params,
    ),
  active_members_by_device: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/devices/active_members_by_device",
      params,
    ),
  estimated_session_minutes: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/devices/estimated_session_minutes",
      params,
    ),
  session_distribution_by_country: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/devices/session_distribution_by_country",
      params,
    ),
  active_members: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/devices/active_members", params),
  most_active_on_mobile: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/devices/most_active_on_mobile",
      params,
    ),
};
